module.exports = __webpack_public_path__ + "static/media/logo-copa-branca.0fbd058d.svg";